import { render, staticRenderFns } from "./CustomersManagementRegister.vue?vue&type=template&id=643f40e6&scoped=true"
import script from "./CustomersManagementRegister.vue?vue&type=script&lang=js"
export * from "./CustomersManagementRegister.vue?vue&type=script&lang=js"
import style0 from "./CustomersManagementRegister.vue?vue&type=style&index=0&id=643f40e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f40e6",
  null
  
)

export default component.exports